export const demoConfig = {
  // Main demo instances
  pokerDesktop: 'https://demo.playzura.io',
  pokerDesktop__local: 'http://localhost/game/desktop/src/lobby.php',
  pokerMobile: 'https://m.demo.playzura.io',
  clubApp: 'http://89.38.128.10:8090/',

  // Contact/Support
  contactSales: 'mailto:info@creatix.tech',

  // Auto-login configuration
  skinId: '3',
  backendApi: import.meta.env.VITE_BACKEND_API || 'https://www.playzura.io/api',
  backendApi__mobile: 'http://192.168.3.134:3001/api',
  backendApi__local: 'http://localhost:3001/api',

  // Demo player pool (players 1..reservedCount are preserved, random picks from reservedCount+1..totalCount)
  demoPlayerPrefix: 'DemoPlayer',
  demoPlayerReservedCount: 10,
  demoPlayerCount: 50,
};

export type DemoConfig = typeof demoConfig;
